import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\DashboardController::dashboardStats
* @see app/Http/Controllers/Admin/DashboardController.php:0
* @route '/admin/api/dashboard-stats'
*/
export const dashboardStats = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboardStats.url(options),
    method: 'get',
})

dashboardStats.definition = {
    methods: ["get","head"],
    url: '/admin/api/dashboard-stats',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DashboardController::dashboardStats
* @see app/Http/Controllers/Admin/DashboardController.php:0
* @route '/admin/api/dashboard-stats'
*/
dashboardStats.url = (options?: RouteQueryOptions) => {
    return dashboardStats.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DashboardController::dashboardStats
* @see app/Http/Controllers/Admin/DashboardController.php:0
* @route '/admin/api/dashboard-stats'
*/
dashboardStats.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboardStats.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::dashboardStats
* @see app/Http/Controllers/Admin/DashboardController.php:0
* @route '/admin/api/dashboard-stats'
*/
dashboardStats.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboardStats.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ReservationController::calendarEvents
* @see app/Http/Controllers/Admin/ReservationController.php:1324
* @route '/admin/api/calendar-events'
*/
export const calendarEvents = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: calendarEvents.url(options),
    method: 'get',
})

calendarEvents.definition = {
    methods: ["get","head"],
    url: '/admin/api/calendar-events',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ReservationController::calendarEvents
* @see app/Http/Controllers/Admin/ReservationController.php:1324
* @route '/admin/api/calendar-events'
*/
calendarEvents.url = (options?: RouteQueryOptions) => {
    return calendarEvents.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ReservationController::calendarEvents
* @see app/Http/Controllers/Admin/ReservationController.php:1324
* @route '/admin/api/calendar-events'
*/
calendarEvents.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: calendarEvents.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ReservationController::calendarEvents
* @see app/Http/Controllers/Admin/ReservationController.php:1324
* @route '/admin/api/calendar-events'
*/
calendarEvents.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: calendarEvents.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ReservationController::calculateDistance
* @see app/Http/Controllers/Admin/ReservationController.php:1482
* @route '/admin/api/calculate-distance'
*/
export const calculateDistance = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: calculateDistance.url(options),
    method: 'post',
})

calculateDistance.definition = {
    methods: ["post"],
    url: '/admin/api/calculate-distance',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ReservationController::calculateDistance
* @see app/Http/Controllers/Admin/ReservationController.php:1482
* @route '/admin/api/calculate-distance'
*/
calculateDistance.url = (options?: RouteQueryOptions) => {
    return calculateDistance.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ReservationController::calculateDistance
* @see app/Http/Controllers/Admin/ReservationController.php:1482
* @route '/admin/api/calculate-distance'
*/
calculateDistance.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: calculateDistance.url(options),
    method: 'post',
})

const api = {
    dashboardStats: Object.assign(dashboardStats, dashboardStats),
    calendarEvents: Object.assign(calendarEvents, calendarEvents),
    calculateDistance: Object.assign(calculateDistance, calculateDistance),
}

export default api